// src/config.js

const appConfig = {
  apps: {
    flowGenerator: {
      id: "129",
      name: "AI Powered Flow Generator",
      icon: "https://assets.apilabz.com/apps/flows.png",
      bodyKey: "instruction",
      credits: 20,
      estimatedTime: 30,
      responseType: "url",
      sampleUrl: "https://storage.googleapis.com/unlimited-apis.appspot.com/user_uaGKAetQjeRfiRoFAhkxTPFjYyn1/generated_diagrams/diagram_1741334397282.html?GoogleAccessId=firebase-adminsdk-ju8t5%40unlimited-apis.iam.gserviceaccount.com&Expires=1743926397&Signature=FTv7TcnhZOPdS2bU28TduWAgG9Htywvm3X2lzrLA7hxY1e5YrS%2BB5fdXQPtH%2FNhDX5dPknXmfnzzuOxdyw%2BoB1EdooUjVRjDjr8RGPuKpApE9X0v54vmJwh47orc%2BET5lGpZ49PlUDDhZvmXtw4yghcJW0apisvwIkNF2hLSa%2BEybSXqvM5R0ioki3rWGWy6Z%2FASaoJiHcZZHsT3pojtAg445saoMwuXF%2FTfhWX0PSsEkC13mqBGtZYhnBuNxfDmOGetaW4kHBI8bgqbxSk8j%2FpEPPUVsInUgI8oHux%2FjM3Rx2YrnQQLz3mqi9hC83VzeXjAGZLfRSo5i%2BcrMRiWUw%3D%3D",
      placeholder: "Convert text descriptions into interactive diagrams using AI-powered diagram engine.",
      inputs: [
        { 
          key: "instruction", 
          label: "Describe your workflow",
          type: "textarea", 
          placeholder: "Describe the flow you want to generate", 
          required: true 
        }
      ]
    },
    imageGenerator: {
      id: "128",
      name: "Image Generator",
      icon: "https://assets.apilabz.com/apps/imageGenerator.png",
      bodyKey: "instruction",
      credits: 50,
      estimatedTime: 30,
      responseType: "url",
      sampleUrl: "https://cdn.lucidpic.com/cdn-cgi/image/w=600,format=auto,metadata=none/66c43abe18502.png",
      placeholder: "Generate high-quality images from text descriptions using AI-powered image engine.",
      inputs: [
        { 
          key: "instruction", 
          type: "textarea", 
          placeholder: "Describe the image you want to generate", 
          required: true 
        }
      ]
    },
    perplexitySearch: {
      id: "132",
      name: "AI Powered Search Engine",
      icon: "https://assets.apilabz.com/apps/aiSearch.png",
      bodyKey: "query",
      credits: 10,
      estimatedTime: 30,
      responseType: "text",
      sampleUrl: "https://labs.perplexity.ai/",
      placeholder: "Perform intelligent search queries using Perplexity AI - powerful search capabilities",
      inputs: [
        { 
          key: "query",
          label: "Perform AI Query", 
          type: "textarea", 
          placeholder: "Enter your search query", 
          required: true 
        }
      ]
    },
    deepVisualResearch: {
      id: "1027",
      name: "Deep Visual Research",
      icon: "https://assets.apilabz.com/apps/deepResearch.png",
      bodyKey: "query",
      credits: 100,
      estimatedTime: 120,
      responseType: "url",
      sampleUrl: "https://apilabz.com/ai-tools/analyst/reports/ece3a30f79",
      placeholder: "Perform deep research and perform advanced analysis to generate comprehensive insights.",
      inputs: [
        { 
          key: "query", 
          type: "textarea", 
          placeholder: "Enter your research topic", 
          required: true 
        }
      ]
    },
    // New modules
    googleSearch: {
      id: "130",
      name: "Google Search",
      icon: "https://assets.apilabz.com/apps/google.png",
      bodyKey: "query",
      credits: 5,
      estimatedTime: 10,
      responseType: "json",
      sampleUrl: "https://github.com/goldbergyoni/nodebestpractices",
      placeholder: "Search the web for any information you need",
      inputs: [
        { 
          key: "query", 
          label: "Search the web",
          type: "textarea", 
          placeholder: "Enter your search query", 
          required: true 
        }
      ]
    },
    pdfExtractor: {
      id: "126",
      name: "PDF Extractor",
      icon: "https://assets.apilabz.com/apps/pdfExtractor.png",
      bodyKey: "pdfUrl",
      credits: 15,
      estimatedTime: 20,
      responseType: "json",
      sampleUrl: "https://www.wmaccess.com/downloads/sample-invoice.pdf",
      placeholder: "Extract structured data from PDF documents",
      inputs: [
        { 
          key: "pdfUrl", 
          type: "text", 
          placeholder: "Enter the URL of the PDF", 
          required: true 
        },
        { 
          key: "jsonStructure", 
          type: "textarea", 
          placeholder: "Enter the JSON structure (optional)", 
          required: false 
        }
      ]
    },
    languageTranslator: {
      id: "511",
      name: "Language Translator",
      icon: "https://assets.apilabz.com/apps/translator.png",
      bodyKey: "text",
      credits: 8,
      estimatedTime: 15,
      responseType: "text",
      sampleUrl: "https://apilabz.com/samples/translation",
      placeholder: "Translate text between different languages",
      inputs: [
        { 
          key: "text", 
          type: "textarea", 
          placeholder: "Enter the text to translate", 
          required: true 
        },
        { 
          key: "targetLanguage", 
          type: "text", 
          placeholder: "Enter the target language code (e.g., en, es, fr)", 
          required: true 
        }
      ]
    },
    fileConverter: {
      id: "400", // Using a dummy ID as not specified
      name: "File Converter",
      icon: "https://assets.apilabz.com/apps/fileConverter.png",
      bodyKey: "fileUrl",
      credits: 20,
      estimatedTime: 25,
      responseType: "url-array",
      sampleUrl: "https://cdn.pixabay.com/photo/2017/09/01/00/15/png-2702691_640.png",
      placeholder: "Convert files between different formats",
      endpoint: "https://ai.apilabz.com/conversion", // Custom endpoint
      inputs: [
        { 
          key: "fileUrl", 
          type: "text", 
          placeholder: "Enter the URL of the file", 
          required: true 
        },
        { 
          key: "fileFormat", 
          type: "text", 
          placeholder: "Enter the current file format", 
          required: true 
        },
        { 
          key: "formatInstructions", 
          type: "textarea", 
          placeholder: "Enter the conversion instructions", 
          required: true 
        }
      ]
    },
    claudeAssistant: {
      id: "5001",
      name: "Claude Assistant",
      icon: "https://assets.apilabz.com/apps/claude.png",
      bodyKey: "prompt",
      credits: 15,
      estimatedTime: 20,
      responseType: "claude-text",
      sampleUrl: "https://apilabz.com/samples/claude",
      placeholder: "Ask Claude AI assistant any question",
      inputs: [
        { 
          key: "prompt", 
          type: "textarea", 
          placeholder: "Enter your question for Claude", 
          required: true 
        }
      ]
    },
    companyLookup: {
      id: "611",
      name: "Company Lookup",
      icon: "https://assets.apilabz.com/apps/company.png",
      bodyKey: "kw",
      credits: 10,
      estimatedTime: 15,
      responseType: "company-json",
      sampleUrl: "https://apilabz.com/api-labs/marketplace",
      placeholder: "Look up information about companies",
      inputs: [
        { 
          key: "kw", 
          label: "Enter Company Name",
          type: "text", 
          placeholder: "Enter company name or domain", 
          required: true 
        }
      ]
    }
  },
  
  // Helper functions for app selection
  getAppIdFromPath: () => {
    if (typeof window === 'undefined') return 'flowGenerator';
    
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    
    // Check if the path segment matches an app
    if (pathSegments.length > 0) {
      const possibleApp = pathSegments[0];
      if (appConfig.apps[possibleApp]) {
        return possibleApp;
      }
    }
    
    // Check query parameter
    const urlParams = new URLSearchParams(window.location.search);
    const appParam = urlParams.get('app');
    if (appParam && appConfig.apps[appParam]) {
      return appParam;
    }
    
    // Default to flowGenerator
    return 'flowGenerator';
  },
  
  getCurrentApp: () => {
    if (typeof window === 'undefined') return appConfig.apps.flowGenerator;
    
    const appId = appConfig.getAppIdFromPath();
    return appConfig.apps[appId];
  },
  
  processResponse: (response, appId) => {
    const app = appConfig.apps[appId];
    
    if (!response) return null;
    
    switch (app.responseType) {
      case 'url':
        if (response.response && response.response.fileURL) {
          return response.response.fileURL;
        }
        break;
      
      case 'url-array':
        if (response.fileUrls && Array.isArray(response.fileUrls)) {
          return response.fileUrls;
        }
        break;
      
      case 'text':
        if (response.response) {
          return response.response;
        }
        return response;
      
      case 'claude-text':
        if (response.response && Array.isArray(response.response) && response.response[0] && response.response[0].text) {
          return response.response[0].text;
        }
        break;
      
      case 'json':
        return JSON.stringify(response.response, null, 2);
      
      case 'company-json':
        if (response.response && response.response.results) {
          return response.response.results;
        }
        break;
      
      default:
        // For backward compatibility
        if (appId === 'flowGenerator' || appId === 'deepVisualResearch') {
          if (response && response.response && response.response.fileURL) {
            return response.response.fileURL;
          }
        } else if (appId === 'imageGenerator') {
          if (response && response.imageUrl) {
            return response.imageUrl;
          }
        } else if (appId === 'perplexitySearch') {
          if (response && response.response) {
            return response.response;
          }
          return response;
        }
    }
    
    return null;
  }
};

export default appConfig;